import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasDocumentSubscription } from '../utils/documentAccess';

/**
 * Hook to check document subscription and redirect if no access
 * @returns {Object} { hasAccess, loading }
 */
export const useDocumentAccess = () => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        setLoading(true);
        const hasSubscription = await hasDocumentSubscription();
        setHasAccess(hasSubscription);
        
        if (!hasSubscription) {
          // Redirect to task list if no subscription
          navigate('/task/tasklist', { replace: true });
        }
      } catch (error) {
        console.error('Error checking document access:', error);
        setHasAccess(false);
        navigate('/task/tasklist', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate]);

  return { hasAccess, loading };
};
